
import { useCallback } from "react";
import { ContentItem } from "../../../content-card/types";
import { GraphLink } from "./useGraphTypes";

export const useGraphLinkBuilder = () => {
  const buildGraphLinks = useCallback((
    contentItems: ContentItem[],
    contentToCollectionMap: Record<string, string>,
    collectionColorMap: Record<string, string>,
    contentToTagsMap: Record<string, string[]>,
    tagColorMap: Record<string, string>,
    collectionLinkOpacity: number,
    tagLinkOpacity: number
  ): GraphLink[] => {
    const links: GraphLink[] = [];

    // Process collection relationships
    const collectionGroups: Record<string, string[]> = {};
    contentItems.forEach(item => {
      const collectionId = contentToCollectionMap[item.id];
      if (collectionId) {
        if (!collectionGroups[collectionId]) {
          collectionGroups[collectionId] = [];
        }
        collectionGroups[collectionId].push(item.id);
      }
    });

    console.log(`Found ${Object.keys(collectionGroups).length} collection groups`);

    Object.entries(collectionGroups).forEach(([collectionId, contentIds]) => {
      const color = collectionColorMap[collectionId] || "#6B7789";
      console.log(`Collection ${collectionId} has ${contentIds.length} items`);
      
      for (let i = 0; i < contentIds.length; i++) {
        for (let j = i + 1; j < contentIds.length; j++) {
          links.push({
            source: contentIds[i],
            target: contentIds[j],
            type: "collection",
            color: color,
            opacity: collectionLinkOpacity / 100
          });
        }
      }
    });

    // Process tag relationships
    const tagGroups: Record<string, string[]> = {};
    contentItems.forEach(item => {
      const tagIds = contentToTagsMap[item.id] || [];
      tagIds.forEach(tagId => {
        if (!tagGroups[tagId]) {
          tagGroups[tagId] = [];
        }
        tagGroups[tagId].push(item.id);
      });
    });

    console.log(`Found ${Object.keys(tagGroups).length} tag groups`);

    Object.entries(tagGroups).forEach(([tagId, contentIds]) => {
      const color = tagColorMap[tagId] || "#8E9196";
      console.log(`Tag ${tagId} has ${contentIds.length} items`);
      
      for (let i = 0; i < contentIds.length; i++) {
        for (let j = i + 1; j < contentIds.length; j++) {
          const existingLink = links.find(
            link => 
              (link.source === contentIds[i] && link.target === contentIds[j]) || 
              (link.source === contentIds[j] && link.target === contentIds[i])
          );
          
          if (!existingLink) {
            links.push({
              source: contentIds[i],
              target: contentIds[j],
              type: "tag",
              color: color,
              opacity: tagLinkOpacity / 100
            });
          }
        }
      }
    });

    console.log(`Created ${links.length} graph links`);
    return links;
  }, []);

  return { buildGraphLinks };
};
